export default "__VITE_ASSET__BnRpSqnm__"